require('./style.less');


var Marionette = require('marionette'),
    SearchModelView = require('../searchModelView/view');


module.exports = Marionette.LayoutView.extend({


    constructor: function() {

        this.channel = null;
        this.onSubmit = null;
        this.dontShowFormButtons = false;
        this.submitButtonTitle = 'Search';
        this.disableInputs = false;
        this.extraFormClassName = null;
        this.focusInputOnShow = false;

        Marionette.LayoutView.apply( this, arguments );

    },

    initialize: function( options ) {

        this.channel = options.channel;

        this.onSubmit = options.onSubmit;

        if ( options.dontShowFormButtons ) {
            this.dontShowFormButtons = true;
        }

        if ( options.submitButtonTitle ) {
            this.submitButtonTitle = options.submitButtonTitle;
        }

        if ( options.disableInputs ) {
            this.disableInputs = options.disableInputs;
        }

        if ( options.extraFormClassName ) {
            this.extraFormClassName = options.extraFormClassName;
        }

        if ( options.focusInputOnShow ) {
            this.focusInputOnShow = true;
        }


    },

    template: require('./template.hbs'),

    regions: {
        searchInputsRegion:  '.fr-search-model-region'
    },

    serializeData: function() {

        var state = this.channel.request('state'),
            searchPerformed = state.get('searchPerformed'),
            hasExtraFormClassName = this.extraFormClassName && this.extraFormClassName.length > 0;

        return {
            hasExtraFormClassName: hasExtraFormClassName,
            extraFormClassName: hasExtraFormClassName ? this.extraFormClassName : '',
            submitButtonTitle: this.submitButtonTitle,
            dontShowFormButtons: this.dontShowFormButtons,
            showSearchButtonAsButtonInfo: searchPerformed, // TODO: ... IN use? maybe add class?
            disableSearch: !this.model.isValid()

        };

    },

    ui: {
        form:           '.fr-search-form',
        submitButton:   '.fr-search-submit'
    },

    events: {
        'submit @ui.form':  'searchSubmitted',
        'click':            'stopPropagationOnClick' // TODO: for when a dropdown -- put in logic or just do better
    },

    onRender: function() {
        this.toggleSubmitBtnEnabled();
    },


    stopPropagationOnClick: function(e) {
        e.stopPropagation();
    },

    onBeforeShow: function() {

        this.searchInputsRegion.show( new SearchModelView({
            channel: this.channel,
            model: this.model,
            disableInputs: this.disableInputs,
            parentForm: this,
            focusInputOnShow: this.focusInputOnShow
        }));
    },

    searchSubmitted: function(e) {
        e.preventDefault();
        this.onSubmit( this.model );
    },

    toggleSubmitBtnEnabled: function() {

        if ( !this.dontShowFormButtons ) {
            this.ui.submitButton[0].disabled = !this.model.isValid();
        }

    }



});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchView/view.js
 ** module id = 591
 ** module chunks = 0
 **/